export interface ExpireModel {
  value: number;
  unit: TIME_UNITS;
}

export enum TIME_UNITS {
  hours = "common.times.hours",
  days = "common.times.days",
  months = "common.times.months",
  none = ""
}

export interface Plan {
  currency: string;
  id: string;
  is_trial_plan: boolean;
  name: string;
  price: number;
  pricing_model: string;
  trial_days: number;
  meta_data: PlanMetaData;
}

export interface PlanMetaData {
  available_payment_methods: string[];
  included_addons: any;
  max_dids: number;
  max_users: number;
  pbx: any;
  plan_upgrade: {
    version: string;
  };
  pricing_info: any;
  shop: any;
  subscription: {
    "update-flow": string;
  };
  traffic: any;
  users: any;
}

export enum DISCOUNT_TYPE {
  PERCENTAGE = "percentage",
  FIXED_AMOUNT = "fixed_amount"
}

export enum DURATION_TYPE {
  ONE_TIME = "one_time",
  FOREVER = "forever",
  LIMITED_PERIOD = "limited_period"
}

export interface CouponRequest {
  id: string;
  name: string;
  discount_type: DISCOUNT_TYPE;
  discount_percentage?: number;
  discount_amount?: number;
  duration_type: DURATION_TYPE;
  period?: number;
  period_unit?: string;
  valid_till?: string;
  max_redemption?: number;
  chargebee_account: string;
  item_constraints?: string[];
}

export interface CouponResponse {
  couponDuration: string;
  discountPercentage: number;
  discountType: string;
  durationMonth: number;
  id: string;
  meta_data: any;
  name: string;
  scope: string;
  status: string;
  validTill: string;
}

export const WIFI_VALUES: string[] = [
  'none',
  'simple',
  'full'
]

export const PAYMENT_METHODS_LIST = ['card', 'sepa', 'all'];

export const PAYMENT_METHODS_MAP = {
  card: ['card'],
  sepa: ['sepa_direct_debit'],
  all: ['card', 'sepa_direct_debit']
}